import { HRISConnectorType } from './types';

export class SyncConnectorError extends Error {
	public connectorType: HRISConnectorType;
	constructor(message: string, connectorType: HRISConnectorType) {
		super(message);
		this.name = 'SyncConnectorError';
		this.connectorType = connectorType;
	}
}

export class InvalidCustomFieldError extends SyncConnectorError {
	constructor(message: string, connectorType: HRISConnectorType) {
		super(message, connectorType);
		this.name = 'InvalidCustomFieldError';
	}
}

export class DisconnectConnectorError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'DisconnectConnectorError';
	}
}
